/**
 * @fileoverview Configuração centralizada da API
 * @description Gerencia URLs da API para desenvolvimento e produção
 */

/**
 * Configuração da API baseada no ambiente
 */
export const API_CONFIG = {
  // URL base da API - vazio para usar proxy relativo
  BASE_URL: '',
  
  // Timeout padrão para requisições
  TIMEOUT: 30000,
  
  // Headers padrão
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Configurações de CORS
  CORS: {
    credentials: 'include',
    mode: 'cors',
  },
};

/**
 * Utilitário para debug da configuração
 */
export const debugApiConfig = () => {
  console.log('🔧 API Configuration:', {
    isDev: import.meta.env.DEV,
    baseUrl: API_CONFIG.BASE_URL,
    viteApiUrl: import.meta.env.VITE_API_URL,
    mode: import.meta.env.MODE,
  });
};

export default API_CONFIG;